import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  readonly loading: WritableSignal<boolean> = signal<boolean>(false);
  readonly isSlowConnection: WritableSignal<boolean> = signal<boolean>(false);
}
